@if (sites().length > 1) {
  <div class="ion-margin-bottom">
    <app-select-site-button [expand]="'block'"
      [selectedSite]="selectedSite()"
      [items]="sites()"
      [hasNew]="true"
      (selected)="onSite($event)"></app-select-site-button>
  </div>
}
<form [formGroup]="formGroup"
  (ngSubmit)="save()">
  <ion-button expand="block"
    color="light"
    [disabled]="selectedSite() == null"
    (click)="selectRoom(selectedSite())">
    @if (selectedRooms().length > 1) {
      {{ selectedRooms().length }} {{ 'room.selected' | translate }}
    } @else if (formGroup.get('room').value) {
      @if (formGroup.get('room').value; as room) {
        {{ room.name }}
      }
    } @else {
      {{ 'calendar.site.area' | translate }}
    }
  </ion-button>
  <ion-button expand="block"
    color="light"
    [disabled]="selectedSite() == null"
    (click)="onLocation()">
    {{ 'calendar.site.location' | translate }}
  </ion-button>
  @if (canManage()) {
    @if (contractors$ | async; as contractors) {
      <div class="ion-margin-bottom">
        <ion-button expand="block"
          shape="round"
          color="light"
          (click)="selectContractor(contractors)">
          @if (formGroup.get('contractor').value; as contractor) {
            <span>
              {{ contractor.name }}
            </span>
          } @else {
            {{ 'subcontractor.select' | translate }}
          }
        </ion-button>
      </div>
    }
  }
  <app-carousel-images [items]="images()"
    (klick)="onImage($event)"></app-carousel-images>
  <div class="flex">
    <app-camera-button [name]="'task'"
      [disabled]="images().length >= maxImages"
      color="light"
      fill="clear"
      (imageUrl)="onUrl($event, 'image')"></app-camera-button>
    <app-take-video [name]="'task'"
      [disabled]="images().length >= maxImages"
      color="light"
      fill="clear"
      (imageUrl)="onUrl($event, 'video')"></app-take-video>
  </div>
  <ion-item lines="none">
    <ion-input autocapitalize="on"
      formControlName="name"
      [placeholder]="'calendar.site.name' | translate">
    </ion-input>
  </ion-item>
  <ion-item class="description"
    lines="none">
    <ion-textarea autocapitalize="on"
      class="description"
      formControlName="description"
      rows="5"
      [placeholder]="'calendar.site.description' | translate">
    </ion-textarea>
    <app-speech-to-text (text)="onMic($event)"></app-speech-to-text>
  </ion-item>
  @if (roleS() !== 'resident') {
    <ion-accordion-group>
      <ion-accordion>
        <ion-item slot="header"
          lines="none"
          color="primary">
          {{ 'item.showMore' | translate }}
        </ion-item>
        <div slot="content">
          @if (canSelectWorker() && users$ | async; as users) {
            <ion-button expand="block"
              shape="round"
              color="tertiary"
              (click)="selectWorker(users)">
              @if (formGroup.get('users').value.length > 0) {
                <div>
                  @for (user of formGroup.get('users').value; track user) {
                    <div>
                      {{ user.name }}
                    </div>
                  }
                </div>
              } @else {
                {{ 'calendar.site.user' | translate }}
              }
            </ion-button>
          }
          <h4>{{ 'calendar.site.options' | translate }}</h4>
          <div class="flex flex-wrap">
            <app-select-day color="tertiary"
              [id]="'adhocSelectDay'"
              [minDate]="minDate()"
              [highlightedDates]="highlightedDates()"
              [name]="'kanban.dateDeadline'"
              size="medium"
              [value]="formGroup.get('date').value"
              (changed)="onDateChange($event)"></app-select-day>
            <ion-button expand="block"
              shape="round"
              color="tertiary"
              (click)="onSchedule()">
              @if (formGroup.get('schedule').value; as schedule) {
                <span>
                  {{ schedule.start | date:'d.M. HH:mm' }} - {{ schedule.end | date:'d.M. HH:mm' }}
                </span>
              } @else {
                {{ 'calendar.site.schedule' | translate }}
              }
            </ion-button>
            <ion-button id="adHocDuration"
              color="tertiary"
              shape="round">
              @if (formGroup.get('duration').value; as duration) {
                <span>
                  {{ duration }}h
                </span>
              } @else {
                {{ 'calendar.site.duration' | translate }}
              }
            </ion-button>
            <ion-modal #durationModal
              class="picker-modal"
              trigger="adHocDuration"
              [keepContentsMounted]="true">
              <ng-template>
                <ion-toolbar>
                  <ion-buttons slot="start">
                    <ion-button (click)="durationModal.dismiss()">
                      {{ 'general.cancel' | translate }}
                    </ion-button>
                  </ion-buttons>
                  <ion-buttons>
                    <ion-button color="danger"
                      (click)="onDuration(0); durationModal.dismiss()">
                      {{ 'general.reset' | translate }}
                    </ion-button>
                  </ion-buttons>
                  <ion-buttons slot="end">
                    <ion-button (click)="onDuration(durationPicker.value); durationModal.dismiss()">
                      {{ 'general.select' | translate }}
                    </ion-button>
                  </ion-buttons>
                </ion-toolbar>
                <ion-picker>
                  <ion-picker-column #durationPicker
                    [value]="formGroup.get('duration').value">
                    @for (duration of pickerColumns; track duration.value) {
                      <ion-picker-column-option [value]="duration.value">{{ duration.text }}</ion-picker-column-option>
                    }
                  </ion-picker-column>
                </ion-picker>
              </ng-template>
            </ion-modal>
            @if (roleS() !== 'worker') {
              <ion-button expand="block"
                shape="round"
                color="tertiary"
                (click)="onAttachments()">
                {{ 'site.attachments' | translate }}
              </ion-button>
            }
          </div>
          <h4>{{ 'calendar.site.repeat' | translate }}</h4>
          <div>
            <ion-button expand="block"
              shape="round"
              color="tertiary"
              (click)="selectRepeatOption()">
              @if (selectedRepeatOption(); as repeatOption) {
                <span>
                  {{ repeatOption.name }}
                </span>
              } @else {
                {{ 'general.select' | translate }}
              }
            </ion-button>
            @if (selectedRepeatOption() != null) {
              @if (selectedRepeatOption().guid === 'daily') {
                <ion-item color="primary"
                  lines="none">
                  <ion-label>{{ 'calendar.site.clock' | translate }}</ion-label>
                  <ion-datetime-button datetime="clock">
                    <div slot="time-target">
                      @if (selectedRepeatOption().time) {
                        {{ selectedRepeatOption().time | date:'HH:mm' }}
                      } @else {
                        --:--
                      }
                    </div>
                  </ion-datetime-button>
                  <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                      <ion-datetime #clock
                        id="clock"
                        presentation="time"
                        locale="fi-FI"
                        [value]="selectedRepeatOption().time"
                        (ionChange)="onRepeatTimeChange($event)">
                        <ion-buttons slot="buttons">
                          <ion-button color="danger"
                            (click)="clock.reset()">{{ 'general.clear' | translate }}</ion-button>
                          <ion-button color="primary"
                            (click)="clock.cancel(true)">{{ 'general.cancel' | translate }}</ion-button>
                          <ion-button color="primary"
                            (click)="clock.confirm(true)">{{ 'general.done' | translate }}</ion-button>
                        </ion-buttons>
                      </ion-datetime>
                    </ng-template>
                  </ion-modal>
                </ion-item>
              }
              <app-select-day color="tertiary"
                [id]="'adhocRepeatStart'"
                [minDate]="minDate()"
                [name]="'calendar.site.start'"
                size="medium"
                [value]="selectedRepeatOption()?.start"
                (changed)="onRepeatStartChange($event)"></app-select-day>
              <app-select-day color="tertiary"
                [id]="'adhocRepeatEnd'"
                [minDate]="selectedRepeatOption()?.start"
                [name]="'calendar.site.end'"
                size="medium"
                [value]="selectedRepeatOption()?.end"
                (changed)="onRepeatEndChange($event)"></app-select-day>
            }
          </div>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  }
  @if (freeLimit()) {

  } @else {
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        type="submit"
        [disabled]="!formGroup.valid || loading()">{{ 'general.save' | translate }}</ion-button>
    </div>
  }
</form>